import Vue from "vue";

function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

    return JSON.parse(new TextDecoder().decode(bytes));
  } catch (_) {
    return null;
  }
}

export default {
  AUTH_TOKEN(state, token) {
    const decoded = decodeJwt(token.replace("JWT ", ""));
    const valid = decoded && decoded.exp > Date.now() / 1000;

    if (!valid) {
      localStorage.removeItem("token");
      delete Vue.api.defaults.headers.common["Authorization"];

      state.authToken = null;
      state.user = null;
      state.merchant = null;
      state.concepts = [];
      state.changePassword = false;

      return;
    }

    state.authToken = token;
    state.user = decoded.user;
    localStorage.setItem("token", token);
    Vue.api.defaults.headers.common["Authorization"] = token;
  },

  AUTH_CHANGE_PASSWORD(state, change) {
    state.changePassword = change;
  },

  AUTH_LOGOUT(state) {
    localStorage.removeItem("token");
    delete Vue.api.defaults.headers.common["Authorization"];

    state.authToken = null;
    state.user = null;
    state.merchant = null;
    state.concepts = [];
    state.changePassword = false;
  },

  SWAP_MERCHANT(state, merchant) {
    state.merchant = merchant;
    localStorage.setItem("merchant", state.merchant.id);
  },

  SET_INVOICE_SERIE(state, invoiceSerie) {
    state.invoiceSerie = invoiceSerie;
    localStorage.setItem("invoiceSerieCode", state.invoiceSerie.code);
  },

  MERCHANTS(state, merchants) {
    var merchantId = localStorage.getItem("merchant");

    state.merchants = merchants;

    if (!state.merchant && merchants.length) {
      state.merchant = merchants[0];

      if (merchantId) {
        for (var i in merchants) {
          if (merchants[i].id === merchantId) {
            state.merchant = merchants[i];
          }
        }
      }
    }

    localStorage.setItem("merchant", state.merchant.id);
  },

  INVOICE_SERIES(state, invoiceSeries) {
    state.invoiceSeries = invoiceSeries;

    const invoiceSerieCode = localStorage.getItem("invoiceSerieCode");

    if (!state.invoiceSerie && invoiceSeries.length) {
      state.invoiceSerie = invoiceSeries[0];

      if (invoiceSerieCode) {
        for (var i in invoiceSeries) {
          if (invoiceSeries[i].code === invoiceSerieCode) {
            state.invoiceSerie = invoiceSeries[i];
          }
        }
      }
    }

    localStorage.setItem("invoiceSerieCode", state.invoiceSerie.code);
  },

  CONCEPTS(state, concepts) {
    state.concepts = concepts;
  },

  RIGHT_ACCESS_SETTINGS(state, rightAccessSettings) {
    state.rightAccessSettings = rightAccessSettings;
  },
};
